var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhitePro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.60625,1.5L0.75,4.4895L6,10.5L6,1.5L2.60625,1.5Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,22.5,0)",
    style: {
      opacity: 0.800000011920929
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.10625,1.5L11.25,4.4895L16.5,10.5L16.5,1.5L13.10625,1.5Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhitePro);
export default __webpack_public_path__ + "static/media/icon-white-pro.49175378.svg";
export { ForwardRef as ReactComponent };